(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Check if announcement bar section is empty and remove it
  function checkAndRemoveEmptyAnnouncementBar() {
    const announcementSection = $('#shopify-section-announcement-bar');

    if (announcementSection.length > 0) { // Check if the section has no visible content or is effectively empty
      const hasVisibleContent = announcementSection.find('*').filter(function() {
        return $(this).is(':visible') && $(this).text().trim() !== '';
      }).length > 0;

// Also check if the section itself is empty (no children or only whitespace)
      const sectionText = announcementSection.text().trim();
      const hasChildren = announcementSection.children().length > 0;

// Check if the section is hidden or has no meaningful content
      const isHidden = announcementSection.is(':hidden') || announcementSection.css('display') === 'none';
      const hasNoContent = sectionText === '' || sectionText.length < 3; // Less than 3 chars is considered empty

      if (isHidden || hasNoContent || ! hasVisibleContent || (! hasChildren && sectionText === '')) {
        announcementSection.remove();
        console.log('Empty announcement bar section removed from DOM');

// Also update the main div margin-top since announcement bar is removed
        if (typeof setMarginTop === 'function') {
          setMarginTop();
        }
      }
    }
  }

// Run the check when DOM is ready
  $(document).ready(function() {
    checkAndRemoveEmptyAnnouncementBar();
  });

  const hiwSection = $('#hiw-section');
  const hiwModal = $('#hiw-modal');
  const hiwTrigger = $('.hiw-trigger');
  const fittingToolBtn = $('#OftBtn');
  const onlineForm = $(".online-fitting-tool-form");
  const modalText = $('.modal-text');
  const HhiwModal = Math.floor(hiwModal.height() + 200);
  const formSubmit = $('#fitting-form-submit');

  hiwTrigger.on("click", function() {

    $(this).parent().parent().hide();
    hiwSection.css({background: "rgb(123 97 255 / 20%)", backdropFilter: "blur(1rem)", height: HhiwModal});
    hiwModal.delay(200).fadeIn(400);

  });
  $('.hiw-exit').on("click", function() {
    hiwModal.slideUp(200, function() {
      hiwSection.css({background: "rgb(123 97 255 / 100%)", height: "80px"});
      hiwTrigger.parent().parent().fadeIn(200);
    });
  });

  fittingToolBtn.on("click", function() {
    modalText.slideUp(200, function() {
      onlineForm.slideDown(20);
    });
  });

  $('.back').on("click", function() {
    onlineForm.slideUp(200, function() {
      modalText.slideDown(200);
    });
  });


  const redirectForm = function(result) {
    $('#form-success-alert').slideDown(200, function() {
      var url = window.location.href;
      window.location.href = url;
    });
  };

  const redirectFormError = function(result) {
    $('#form-error-alert').slideDown(200).delay(1000).slideUp(200);
  };


  formSubmit.click(function(e) {
    e.preventDefault();


    var form = $("#bootstrapForm");
    var actionURL = form.attr("action");
    const formEmail = $('#emailAddress').val();
    const formName = $('#1610322548').val();
    const formLastname = $('#1610322548').val();

    if (formEmail !== '' && formName !== '' && formLastname !== '') {
      $.ajax({url: actionURL, data: form.serialize(), cache: true}).done(function(data) {}).fail(function(data) {
        setTimeout(redirectForm, 2000)

      });

    } else {
      setTimeout(redirectFormError, 2000)
    }


  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Collections-slide"] && !Shopify.designMode) return;
  try {
    
    var CollectionSlider = $('.slide');
    var currentSlide = 1;
    var slide = document.querySelectorAll('[data-slide]');	
    console.log(slide);
    var totalSlides = slide.length;
    var progressBar = document.querySelector('.progressBar .progress');
    var currentSlideEl = document.querySelector('.currentSlide');
    var totalSlidesEl = document.querySelector('.totalSlides');
    var slideNavEl = document.querySelector('.slideNavEl');
    
    
      
  CollectionSlider.slick({
  infinite: true,
  centerMode: true,
  prevArrow: '<span class="slide-arrow "><svg class="icons prev-arrow chevron-prev"><use href="#chevron-right"></use></svg></span>',
  nextArrow: '<span class="slide-arrow "><svg class="icons next-arrow chevron-next"><use href="#chevron-right"></use></svg></span>',
  appendArrows: slideNavEl,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
          slidesToShow: 4,
          infinite: true
        } 
  }, {
      
      breakpoint: 1342,
      settings: {
          slidesToShow: 3,
          infinite: true
      }

  }, {

      breakpoint: 1080,
      settings: {
          slidesToShow: 2,
          infinite: true
      }

  }, {

      breakpoint: 560,
      settings: {
          slidesToShow: 1,
          infinite: true
      }

  }]
});

  for (var i = 0; i < slide.length; i++) {
    slide[i].setAttribute('data-slide', i + 1);
  }
  

  function updateSlide() {
    currentSlideEl.innerHTML = currentSlide;
    totalSlidesEl.innerHTML = totalSlides;
    progressBar.style.width = (currentSlide / totalSlides) * 100 + '%';
  }

  updateSlide();

  function nextSlide() {
    if (currentSlide < totalSlides) {
      currentSlide++;
      updateSlide();
    } else {
      currentSlide = 1;
      updateSlide();
    }
  }
  
  function prevSlide() {
    if (currentSlide > 1) {
      currentSlide--;
      updateSlide();
    } 
    else {
      currentSlide = totalSlides;
      updateSlide();
    }
  }


  
  slideNavEl.addEventListener('click', function(e) {
    if (e.target.classList.contains('next-arrow')) {
      nextSlide();
    } else if (e.target.classList.contains('prev-arrow')) {
      prevSlide();
    } else {
      return;
    }
    
    
  });


  // handle counter with the drag and swipe events
  CollectionSlider.on('swipe', function(event, slick, direction) {
    if (direction === 'left') {
      nextSlide();
    } else if (direction === 'right') {
      prevSlide();
    }
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-item-section"] && !Shopify.designMode) return;
  try {
    
lightbox.option({
  'resizeDuration': 200,
  'wrapAround': true
})

document.addEventListener('DOMContentLoaded', function() {
  // Select all grid items
  var gridItems = document.querySelectorAll('.grid-item');

  gridItems.forEach(function(item) {
    var trigger = item.querySelector('.hover-trigger');
    var hoverElement = item.querySelector('.hover-element');

    if (trigger && hoverElement) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();

        // Toggle 'active' class on the hover element
        hoverElement.classList.toggle('active');

        // Get current state of 'aria-expanded'
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // Toggle 'aria-expanded' attribute
        trigger.setAttribute('aria-expanded', !isExpanded);

        // Update the icon based on the new state
        var icon = trigger.querySelector('.trigger-icon i');
        if (!isExpanded) {
          // Now expanded, change icon to 'minus'
          icon.classList.remove('fa-plus');
          icon.classList.add('fa-minus');
        } else {
          // Now collapsed, change icon to 'plus'
          icon.classList.remove('fa-minus');
          icon.classList.add('fa-plus');
        }

        // Optionally update the aria-label
        trigger.setAttribute('aria-label', isExpanded ? 'Show Details' : 'Hide Details');
      });
    }
  });

  // Close hover elements when clicking outside
  document.addEventListener('click', function(event) {
    gridItems.forEach(function(item) {
      var hoverElement = item.querySelector('.hover-element');
      var trigger = item.querySelector('.hover-trigger');

      if (hoverElement && hoverElement.classList.contains('active')) {
        if (!item.contains(event.target) && !hoverElement.contains(event.target) && !trigger.contains(event.target)) {
          // Remove 'active' class
          hoverElement.classList.remove('active');

          // Set 'aria-expanded' to false
          trigger.setAttribute('aria-expanded', 'false');

          // Update the icon to 'plus'
          var icon = trigger.querySelector('.trigger-icon i');
          icon.classList.remove('fa-minus');
          icon.classList.add('fa-plus');

          // Optionally update the aria-label
          trigger.setAttribute('aria-label', 'Show Details');
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();




  } catch(e) { console.error(e); }
})();
})();
